export const IPFS_URL = 'ipfs://';
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs/';
